<template>
  <div
    class="
      relative
      w-full
      p-7
      before:absolute
      before:bottom-0
      before:left-7
      before:right-7
      before:h-1px
      before:bg-gray-400
      after:absolute
      after:-top-1px
      after:left-7
      after:right-7
      after:h-1px
      after:bg-gray-400
      lg:w-1/2
    "
  >
    <div class="flex flex-wrap py-12 lg:flex-nowrap">
      <div v-if="!isLargeScreen">
        <div>
          <h3 class="font-medium mb-4 lg:text-16px">{{ name }}</h3>
          <article v-if="description" v-html="description"></article>
        </div>
      </div>

      <Image :name="name" :image="image" />

      <div
        class="
          flex-grow flex flex-col
          w-7/12
          pr-5
          sm:pr-13
          lg:w-full lg:pr-0 lg:mx-14
        "
      >
        <h3 class="font-medium mb-4 lg:block lg:text-16px" v-if="isLargeScreen">
          {{ name }}
        </h3>
        <article
          v-if="description && isLargeScreen"
          v-html="description"
        ></article>

        <div class="lg:mt-auto">
          <SelectField
            :options="options"
            v-model="selectedItem"
            @change.stop="setSelectedSelectService(id, selectedItem, selected)"
            :disabled="disabled || locked"
          />
        </div>
      </div>

      <div
        class="
          flex-shrink-0 flex flex-col
          justify-between
          w-5/12
          pl-5
          sm:pl-13
          lg:w-52 lg:pl-0
        "
        v-if="!locked"
      >
        <div class="">
          <Button
            variant="secondary"
            size="full"
            :disabled="disabled"
            @click="setSelectedSelectService(id, selectedItem, true)"
            v-if="!selected"
          >
            {{ __('btn_add') }}
          </Button>
          <Button
            variant="secondary"
            size="full"
            :disabled="disabled"
            @click="setSelectedSelectService(id, selectedItem, false)"
            v-else
          >
            {{ __('btn_remove') }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from 'vue';
import { useMediaQuery } from '@vueuse/core';
import { formatPrice } from '@/libraries/Helpers';
import { setSelectedSelectService } from '@/stores/Services';

import Image from '@/components/Service/Image';
import Button from '@/components/Button';
import SelectField from '@/components/Form/SelectField';

export default {
  components: {
    Image,
    Button,
    SelectField
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    locked: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const selectedItem = ref(null);

    watch(
      () => props.items,
      (items) => {
        items.forEach((item) => {
          if (item.selected) {
            selectedItem.value = item.id;
          }
        });
      },
      {
        immediate: true
      }
    );

    const options = computed(() => {
      const collect = [];

      if (props.items) {
        props.items.forEach((item) => {
          collect.push({
            value: item.id,
            label: `${item.name}, ${formatPrice(item.price)}${props.currency}`
          });
        });
      }

      return collect;
    });

    const isLargeScreen = useMediaQuery('(min-width: 1024px)');

    return {
      selectedItem,
      setSelectedSelectService,
      options,
      isLargeScreen
    };
  }
};
</script>
